import { useEffect, useState, useMemo } from "react";
import { PlusCircleOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Spin, Modal, Button, Dropdown } from "antd";
import TableComponent from "../../components/TableComponent";
import { createColumn } from "../../utils/tableUtils";
import { useNavigate } from "react-router-dom";
import { tableDateFormatter } from "../../utils/formatDate";
import MainButtonComponent from "../../components/MainButtonComponent";
import {
	HeaderComponent,
	Container,
	ContainerHeader,
	ActionButtonComponent,
	StatusCell
} from "./styles";
import { useBannerContext } from "../../context/BannerContext/BannerContext";

const BannerList: React.FC = () => {
	const [tableData, setTableData] = useState<any[]>([]);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentItem, setCurrentItem] = useState<any>(null);
	const { bannerList, removeBanner, getBannerList, operationStatus } = useBannerContext();

	const navigate = useNavigate();

	useEffect(() => {
		getBannerList();
	}, []);

	useEffect(() => {
		setTableData(bannerList);
	}, [bannerList]);

	const columns = useMemo(() => [
		createColumn({
			title: "Sıra No",
			dataIndex: "displayOrder",
			width: 20,
			sorterType: "numeric"
		}),
		createColumn({
			title: "Başlık",
			dataIndex: "headerName",
			width: 80,
			sorterType: "string",
		}),
		createColumn({
			title: "Menüsü Var/Yok",
			dataIndex: "hasMenu",
			width: 30,
			sorterType: "boolean",
			render: (text, record) => (
				<StatusCell $hasMenu={record.hasMenu}>{record.hasMenu ? "Var" : "Yok"}</StatusCell>
			),
		}),
		createColumn({
			title: "Tarih",
			dataIndex: "creationDate",
			width: 30,
			sorterType: "string",
			render: (text) => tableDateFormatter(text, "DD.MM.YYYY"),
		}),
		createColumn({
			title: "",
			dataIndex: "action",
			width: 20,
			render: (text, record: any) => {
				const menuItems = [
					{
						key: "edit",
						label: "Güncelle",
						onClick: () => navigate(`/edit-banner/${record.bannerId}`),
					},
					{
						key: "delete",
						label: "Sil",
						onClick: () => {
							setCurrentItem(record);
							setIsModalVisible(true);
						},
					},
				];

				return (
					<Dropdown menu={{ items: menuItems }} trigger={["click"]}>
						<MoreOutlined />
					</Dropdown>
				);
			},
		}),
	], [tableData]);

	return (
		<div>
			<HeaderComponent>Banner</HeaderComponent>
			<Container>
				<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
					<ContainerHeader>
						<ActionButtonComponent>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<EditOutlined />}
								onClick={() => navigate("/order-banners")}
							>
								Sırala
							</MainButtonComponent>
						</ActionButtonComponent>
						<ActionButtonComponent>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<PlusCircleOutlined />}
								onClick={() => navigate("/add-banner")}
							>
								Yeni Ekle
							</MainButtonComponent>
						</ActionButtonComponent>
					</ContainerHeader>
				</Spin>
				{!(operationStatus.type === "loading" && operationStatus.operation === "fetch") && (
					<TableComponent
						columns={columns}
						dataSource={tableData}
					/>
				)}
			</Container>
			<Modal
				title="Banner Sil"
				open={isModalVisible}
				onCancel={() => setIsModalVisible(false)}
				footer={[
					<Button key="back" type="text" onClick={() => setIsModalVisible(false)}>
						İptal
					</Button>,
					<Button
						loading={operationStatus.type === "loading" && operationStatus.operation === "delete"}
						key="submit"
						type="primary"
						danger
						onClick={async () => {
							await removeBanner(currentItem?.bannerId);
							setIsModalVisible(false);
						}}
					>
						Evet
					</Button>,
				]}
			>
				<p><strong>{`"${currentItem?.headerName}"`}</strong> bannerını silmek istediğinizden emin misiniz?</p>
			</Modal>
		</div>
	);
};

export default BannerList;
